/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Land_Skin_9_TitleInputs */

const en_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land skin 9`)
};

const ar_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const de_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const es_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const fr_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const it_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ja_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ko_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const pt_br_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ru_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const th_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const tr_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_cn_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_tw_land_skin_9_title = /** @type {(inputs: Land_Skin_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land skin 9`)
};

/**
* | output |
* | --- |
* | "Land skin 9" |
*
* @param {Land_Skin_9_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const land_skin_9_title = /** @type {((inputs?: Land_Skin_9_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Land_Skin_9_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_land_skin_9_title(inputs)
	if (locale === "ar") return ar_land_skin_9_title(inputs)
	if (locale === "de") return de_land_skin_9_title(inputs)
	if (locale === "es") return es_land_skin_9_title(inputs)
	if (locale === "fr") return fr_land_skin_9_title(inputs)
	if (locale === "it") return it_land_skin_9_title(inputs)
	if (locale === "ja") return ja_land_skin_9_title(inputs)
	if (locale === "ko") return ko_land_skin_9_title(inputs)
	if (locale === "pt_br") return pt_br_land_skin_9_title(inputs)
	if (locale === "ru") return ru_land_skin_9_title(inputs)
	if (locale === "th") return th_land_skin_9_title(inputs)
	if (locale === "tr") return tr_land_skin_9_title(inputs)
	if (locale === "zh_cn") return zh_cn_land_skin_9_title(inputs)
	return zh_tw_land_skin_9_title(inputs)
});